import React from "react";
import { connect } from "react-redux";
import styles from "./style.module.scss";
// import bg_mobile from "~/assets/img/mobile/common/bg_mobile.svg";
import cx from "classnames";
import { get } from "lodash";

class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hostpital_name: "Bệnh viện Đại Học Y Dược TP.HCM"
    };
  }

  render() {
    const fullName = get(this.props, "info.fullName", "");
    const userName = get(this.props, "info.userName", "");

    const displayName = fullName !== "" ? fullName : userName;

    return (
      <div
        className={cx(styles.bg_top_mobile, styles.bg_gradient)}
        // style={{ backgroundImage: `url(${bg_mobile})` }}
      >
        <p className={styles.say_hello}>
          Xin chào <b>{displayName}</b>
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    user: { info }
  } = state;
  return {
    info
  };
};

export default connect(mapStateToProps, {})(Welcome);
